const LessonModel = {
  created: "date",
  updated: "date",
  description: "string",
  video: ["hasOne", "video"],
  thumbnail: "object",
  instructors: ["hasMany", "instructor"],
  versions: ["hasMany", "lesson"],
  duration: (value) => Math.floor(value),
}

export default LessonModel
